import { render, staticRenderFns } from "./select-org.vue?vue&type=template&id=e2ef6970"
import script from "./select-org.vue?vue&type=script&lang=js"
export * from "./select-org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports